import { Button, Center, Stack, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { IconFigmaLockRounded } from '@/assets/icons';

export const AccessRestrictedCard = () => {
  const { t } = useTranslation();

  return (
    <Center h={500} w="100%">
      <Stack
        align="center"
        gap={14}
        px={56}
        py={48}
        w={480}
        style={{
          borderRadius: 12,
          backgroundColor: 'var(--color-bg-surface)',
          border: '1px solid var(--color-border-default)'
        }}
      >
        <Center
          w={60}
          h={60}
          style={{ borderRadius: 12, backgroundColor: 'var(--color-accent-secondary-soft)' }}
        >
          <IconFigmaLockRounded size={26} color="var(--color-text-primary)" />
        </Center>
        <Title order={2} fz={22} ta="center" style={{ color: 'var(--color-text-primary)' }}>
          {t('users.roles.accessRestrictedTitle')}
        </Title>
        <Text fz={14} ta="center" style={{ color: 'var(--color-text-secondary)' }}>
          {t('users.roles.accessRestrictedMessage')}
        </Text>
        <Text fz={13} lh="19px" ta="center" style={{ color: 'var(--color-text-muted)' }}>
          {t('users.roles.accessRestrictedHint')}
        </Text>
        <Text fz={13} lh="19px" ta="center" style={{ color: 'var(--color-text-muted)' }}>
          {t('users.roles.accessRestrictedContact')}
        </Text>
        <Button component={Link} to="/">
          {t('common.backToDashboard')}
        </Button>
      </Stack>
    </Center>
  );
};
